





















































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import Vue2Filters from 'vue2-filters'
import Select from '@/components/Select.vue'
import {
  EFacilityPayerTypePaymentOrder, IPayerType
} from '@zunta/configurations'
import SortableDirective from '@/directives/sortable'
import { waitUntil } from '@/utils/helpers'
import { ISelectItem } from '@/interfaces'
import { FacilityModule } from '@/store/modules/facility.module'
const uniq = require('lodash.uniq')

interface IPayerTypeItem {
  payerType: number,
  payerName: string,
  paymentOrder: EFacilityPayerTypePaymentOrder,
  checked: boolean
}

@Component({
  directives: {
    sortable: new SortableDirective()
  },
  mixins: [Vue2Filters.mixin],
  components: {
    Checkbox,
    Icon,
    Select
  },
  name: 'PayerTypes',
  props: {
    appliedTo: {
      type: Array,
      default: () => []
    }
  }
})
export default class PayerTypes extends Vue {
  EFacilityPayerTypePaymentOrder: any = EFacilityPayerTypePaymentOrder
  localPayerTypes: Array<IPayerTypeItem> = []
  isLoading: boolean = false
  get openBalance () {
    return this.$store.state.resident.openBalance
  }

  get facility () {
    return typeof this.$store.state.resident.selectedResident.facility === 'number'
        ? this.$store.state.resident.selectedResident.facility
        : this.$store.state.resident.selectedResident.facility.id
  }

  get isAllChecked () {
    return !this.localPayerTypes.filter((item: any) => !item.checked).length
  }

  async mounted () {
    this.$watch('appliedTo', (val: any) => {
      this.localPayerTypes = val
    }, { immediate: true })

    this.isLoading = true
    await Promise.all([
      waitUntil(() => !!this.openBalance)
    ])

    setTimeout(() => {
      this.isLoading = false
    }, 300)
  }

  togglePayerType (item: IPayerTypeItem) {
    const index = this.localPayerTypes.findIndex((payer: IPayerTypeItem) => item.payerType === payer.payerType)
    this.localPayerTypes[index].checked = !this.localPayerTypes[index].checked
    this.emitChange()
  }

  changePayerTypeSettingPaymentOrder (payerTypeItem: IPayerTypeItem, sItem: ISelectItem) {
    payerTypeItem.paymentOrder = sItem.value
    this.emitChange()
  }

  toggleAll () {
    if (this.openBalance) {
      this.localPayerTypes = this.localPayerTypes.map((item: IPayerTypeItem) => {
        return {
          ...item,
          checked: !this.isAllChecked
        }
      })
    }
    this.emitChange()
  }

  getPayerTypeAmount (payerTypeId: number) {
    const item = this.openBalance.items.find((item: any) => {
      return item.payerType === payerTypeId
    })
    return item ? item.amount : 0
  }

  updateSelectedOrder (event: any) {
    const { oldIndex, newIndex } = event
    const payerType = this.localPayerTypes[oldIndex]
    this.localPayerTypes[oldIndex] = this.localPayerTypes[newIndex]
    this.localPayerTypes[newIndex] = payerType
    this.emitChange()
  }

  emitChange () {
    this.$emit('change', this.localPayerTypes.filter((item) => item.checked === true)
        .map((item) => {
          return {
            payerType: item.payerType,
            payerName: item.payerName,
            paymentOrder: item.paymentOrder
          }
        }))
  }
}
